import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

// Get vehicles that are available but not yet saved
const getAvailableVehicles = async (user_id) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/vehicle-list/?user_id=${user_id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Get already saved vehicles for a user
const getVehicles = async (user_id) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/vehicle-data/?user_id=${user_id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const getCompanyVehicles = async (user_id) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/vehicles/?user_id=${user_id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};
// Create a single vehicle
const createVehicle = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/vehicle-data/?user_id=${data?.user_id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Delete a vehicle by ID
const deleteVehicle = async (vehicle_id) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/vehicle-data/?vehicle_id=${vehicle_id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Update a vehicle by ID
const updateVehicle = async (vehicle_id, data) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/vehicle-data/?vehicle_id=${vehicle_id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Bulk create multiple vehicles
const createBulkVehicles = async (data, user_id) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/vehicle-data/?user_id=${user_id}`,
      Array.isArray(data) ? data : [data],
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Get all vehicles and their access status for a user
const getUserVehicleAccess = async (userId) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/vehicle-access/?user_id=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Grant access to vehicles for a user
const grantVehicleAccess = async (userId, vehicleIds, hasFullAccess = true) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/vehicle-access/`,
      {
        user_id: userId,
        vehicle_ids: vehicleIds,
        has_full_access: hasFullAccess,
        action: 'grant'
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Revoke access to vehicles for a user
const revokeVehicleAccess = async (userId, vehicleIds) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/vehicle-access/`,
      {
        user_id: userId,
        vehicle_ids: vehicleIds,
        action: 'revoke'
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

export {
  getAvailableVehicles,
  getVehicles,
  createVehicle,
  deleteVehicle,
  updateVehicle,
  createBulkVehicles,
  getUserVehicleAccess,
  grantVehicleAccess,
  revokeVehicleAccess,
  getCompanyVehicles
};
